import { userAccountActions } from './userAccount'

export const {
  refreshContactPhoneNumber,
  refreshCorrespondenceEmail,
  refreshMainAddress,
  refreshCorrespondenceAddress,
} = userAccountActions
